import { Object } from 'fabric/fabric-impl';
import { ArrowDown, ArrowUp, MoveDown, MoveUp } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import React from 'react';
import { useSelector } from 'react-redux';
import layerManager from 'modules/overlay-canvas/addons/layer-manager';
import { selectFabricManager } from 'modules/template-editor/store/editor/selectors';
import { Button, Item } from '../styles';
import { theme } from 'styles/theme/theme';

interface LayerControlsProps {
  object?: Object;
  useActiveObject?: boolean;
}

const LayerControls: React.FC<LayerControlsProps> = ({ object, useActiveObject }) => {
  const fabricManager = useSelector(selectFabricManager);

  const handleLayerAction = (action: 'front' | 'back' | 'forward' | 'backward') => {
    const targetObject = useActiveObject ? (fabricManager?.canvas.getActiveObject() as Object) : object;
    if (!targetObject) return;

    if (action === 'front') {
      layerManager.sendToFront(targetObject);
    } else if (action === 'back') {
      layerManager.sendToBack(targetObject);
    } else if (action === 'forward') {
      layerManager.sendForward(targetObject);
    } else {
      layerManager.sendBackward(targetObject);
    }
  };

  return (
    <Item>
      <Trans>Слои</Trans>
      <Button onClick={() => handleLayerAction('front')} icon={<MoveUp size={16} color={theme.colors.Gray96} />}>
        <Trans>Поднять вверх</Trans>
      </Button>
      <Button onClick={() => handleLayerAction('forward')} icon={<ArrowUp size={16} color={theme.colors.Gray96} />}>
        <Trans>На 1 слой вверх</Trans>
      </Button>
      <Button onClick={() => handleLayerAction('backward')} icon={<ArrowDown size={16} color={theme.colors.Gray96} />}>
        <Trans>На 1 слой вниз</Trans>
      </Button>
      <Button onClick={() => handleLayerAction('back')} icon={<MoveDown size={16} color={theme.colors.Gray96} />}>
        <Trans>Переместить вниз</Trans>
      </Button>
    </Item>
  );
};

export default LayerControls;
